// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2Dykl","modalFooterButton":"ModalNotes_modalFooterButton__1H7oF"};